module.exports = __webpack_public_path__ + "static/media/icon-mini-program.jpg";